import { Step } from '@opendoor/cinderblocks/platform/Timeline';

import { TaskCardProps } from 'shared/components/TaskCard';
import { UnderContractTaskTitles } from 'sellDirect/helpers/useSellDirectTasks';

export enum SellDirectPostSignTimelineItems {
  OFFER_ACCEPTED = 'Offer accepted',
  SERVICE_PROVIDER_INFO = 'Service provider info',
  DISCLOSURES = 'Disclosures',
  FINAL_WALKTHROUGH = 'Finalize closing details',
  CLOSE_AND_GET_PAID = 'Close and get paid',
}

type OverviewHeaderStepsReturnType = {
  overviewHeaderSteps: Step[];
  currentStep: Step;
};

/**
 * Returns the OverviewHeader steps in the correct order, as well as the current step
 */
export const getOverviewHeaderSteps = (tasks?: TaskCardProps[]): OverviewHeaderStepsReturnType => {
  const UnderContractStepsDefaultOrder: Array<{ taskTitle: string } & Step> = [
    {
      name: SellDirectPostSignTimelineItems.SERVICE_PROVIDER_INFO,
      taskTitle: UnderContractTaskTitles.SERVICE_PROVIDER_INFO,
    },
    {
      name: SellDirectPostSignTimelineItems.DISCLOSURES,
      taskTitle: UnderContractTaskTitles.DISCLOSURES,
    },
    {
      name: SellDirectPostSignTimelineItems.FINAL_WALKTHROUGH,
      taskTitle: UnderContractTaskTitles.FINAL_WALKTHROUGH,
    },
  ];

  let lastCompletedStep: string = SellDirectPostSignTimelineItems.OFFER_ACCEPTED;
  const underContractSortedSteps = UnderContractStepsDefaultOrder.map((step, idx) => {
    const taskCard = tasks?.find((task) => task.title === step.taskTitle);
    return { ...step, isDone: taskCard?.isDone, idx };
  })
    .sort((a, b) => {
      // return the step that isDone first. If they are both done, return the default sort order (so compare idxs)
      if (a.isDone && !b.isDone) {
        return -1;
      } else if (b.isDone && !a.isDone) {
        return 1;
      }

      return a.idx - b.idx;
    })
    .map((stepExtended) => {
      const name = stepExtended.name;
      if (stepExtended.isDone) {
        lastCompletedStep = name;
      }
      return { name };
    });

  const overviewHeaderSteps: Step[] = [
    { name: SellDirectPostSignTimelineItems.OFFER_ACCEPTED },
    ...underContractSortedSteps,
    { name: SellDirectPostSignTimelineItems.CLOSE_AND_GET_PAID },
  ];

  // get the index of the last completed Step, and then get the next item in the list
  const lastCompletedIndex = overviewHeaderSteps.findIndex(
    (step) => step.name === lastCompletedStep,
  );
  const currentStep = overviewHeaderSteps[lastCompletedIndex + 1];

  return { overviewHeaderSteps, currentStep };
};
